import { FooterColumn } from '../models';

interface FooterProps {
  footerColumns: FooterColumn[];
  data: any[];
  className: string;
}

export default function Footer({
  footerColumns,
  data,
  className,
}: FooterProps) {
  return (
    <tr className={className}>
      {footerColumns.map((column) => (
        <td key={column.name}>{column.cell(data)}</td>
      ))}
    </tr>
  );
}
